import Card from '@app/components/Card';
import { rem } from '@app/styles/theme/layout';
import styled from '@emotion/styled';
import theme from '@app/styles/theme';

export const ShippingCard = styled(Card)`
  font-weight: bold;
  cursor: pointer;
`;

export const Notice = styled.aside`
  line-height: 1.5;
  color: ${theme.colors.darkGray};
  font-style: italic;
`;

export const Error = styled.p`
  color: ${theme.colors.red};
  margin-block-end: ${rem(5)};
`;
